import { Injectable } from "@angular/core";
import { addDays, compareAsc, parse } from 'date-fns';
import { User } from "@teammood/shared/util/user";

@Injectable(
    { providedIn: 'root' }
  )
export class AnnouncementService {
    constructor(){}

    showForUserFunction(user: User) {
        if (user && user.created) {
            const today = new Date;
            // show it to new users for 7 days
            const dateString = user.created;
            const userCreation = parse(dateString, 'dd-MM-yyyy', new Date())
            const userCreationPlusSevenDays = addDays(userCreation, 7);
            const compare = compareAsc(today, userCreationPlusSevenDays);
            return compare <= 0;
        }
        return false;
    }
}